import { useEffect } from 'react';
import { AppLayout } from '../components/layout/AppLayout';
import { CreditPurchase } from '../components/dashboard/CreditPurchase';
import { useCredits } from '../hooks/useCredits';

export default function Credits() {
  const { refetch } = useCredits();

  useEffect(() => {
    refetch();
  }, [refetch]);

  return (
    <AppLayout>
      <div className="max-w-6xl mx-auto">
        <CreditPurchase />
      </div>
    </AppLayout>
  );
}

